<i18n src="../translations"></i18n>

<template>
  <div>
    <div
      class="info-link qa-ProductCard__showCarTypes"
      role="button"
      tabindex="0"
      :aria-label="$t('product-info-sections.suitable-cars')"
      @click="show()"
      @keydown.enter.prevent="show()"
      @keydown.space.prevent="show()"
    >
      {{ $t('product-info-sections.suitable-cars') }}
      <ArrowOpenModalSvg class="info-arrow" />
    </div>

    <Dialog
      ref="carTypesDialog"
      class="pdp-info-dialog"
      :click-outside="true"
      :title="$t('product-info-sections.suitable-cars')"
      :use-frame-padding="false"
    >
      <Table
        :is-ajax="true"
        :url="ajaxUrl"
        :load-more="true"
        :load-more-label="$t('product-info-sections.more-car-types')"
        :initial-rows-limit="4"
        table-key="carTypes"
        :has-border="false"
        @tableIsEmpty="$emit('empty', 'carTypes')"
      />
    </Dialog>
  </div>
</template>

<script>
import ArrowOpenModalSvg from 'Components/00-generated/ArrowOpenModalSvg';
import Dialog from 'Components/02-molecules/dialog/Dialog';
import Table from 'Components/01-atoms/table/Table';
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'PdpInfoCarLink',
  components: { ArrowOpenModalSvg, Dialog, Table },
  mixins: [globalMixin],
  props: {
    productId: { type: String, required: true },
  },
  computed: {
    ajaxUrl() {
      if (!this.productId) return '';
      return this.interpolateUrl(
        this.frontFacingPath('search.ajax.product.car.data'),
        { productId: this.productId }
      );
    },
  },
  methods: {
    interpolateUrl(path, params) {
      const interpolate = this.$options.filters?.interpolate;
      if (typeof interpolate === 'function') {
        return interpolate(path, params);
      }
      return path.replace('{productId}', this.productId);
    },
    show() {
      if (!this.productId) return;
      this.$refs.carTypesDialog.show();
    },
  },
};
</script>

<style scoped lang="scss">
@import './_linkBase.scss';

.info-link {
  margin-bottom: var(--space-3);
}
</style>
